import React from 'react';
import { useTranslation } from 'react-i18next';
import Card from 'shared/components/Card/Card';
import { ArrowUpRightFromSquare } from 'shared/components/icons/ArrowUpRightFromSquare';
import { CardDescription, CardDescriptionBold } from 'shared/components/Card/Card.styles';
import { CardBody } from '../SystemDetails.styles';

export interface InstallerCardProps {
  installer: string;
  installerUrl: string;
}

export function InstallPartnerCard({ installer, installerUrl }: InstallerCardProps) {
  const { t } = useTranslation();

  return (
    <Card
      title={t('status.installPartner')}
      actionText={t('status.visitWebiste')}
      actionIcon={{ element: <ArrowUpRightFromSquare /> }}
      url={installerUrl}
      hasHeaderIcons={false}
    >
      <CardBody>
        <CardDescription as="body">{t('status.installPartner')}</CardDescription>
        <CardDescriptionBold as="body">{installer || ''}</CardDescriptionBold>
      </CardBody>
    </Card>
  );
}

export default InstallPartnerCard;
